import aspectStoreModule from '@/app/aspect/apsect-state';
import i18n from '@/plugins/i18n';

export const initTermHints = (): void => {
  if (!aspectStoreModule.selectedCourseAspectInstance) {
    return;
  }

  const terms = aspectStoreModule.selectedCourseAspectInstance.terms;

  document.querySelectorAll('.term-reference').forEach((item) => {
    // @ts-ignore
    const termId = item.dataset.termId;
    const term = terms.find((t) => t.id === termId);

    item.setAttribute('role', 'button');
    item.setAttribute('tabindex', '0');
    item.setAttribute('aria-expanded', 'false');
    item.setAttribute('aria-haspopup', 'true');

    if (term) {
      const hintHtml = `<div class="term-hint" data-term-id="${term.id}">
                <div class="term-hint-wrapper">
                <div class="term-hint-content"><strong>${term.title}</strong><br>${term.content}</div>
                <button class="close-button border-0" aria-label="${i18n.t('player.close')}"></button>
              </div>
          </div>`;
      item.parentElement?.insertAdjacentHTML('afterbegin', hintHtml);
    }
  });

  const hideVisibleHint = () => {
    const visibleHint = document.querySelector('.term-hint.visible');
    if (visibleHint) {
      visibleHint.classList.remove('visible');
      const termReference = document.querySelector('.term-reference');
      if (termReference) {
        termReference.setAttribute('aria-expanded', 'false');
      }
    }
  }

  const showHintPopup = (e: any) => {
    hideVisibleHint();

    const termId = e.target.dataset.termId
    const context = e.target.parentElement;
    const posTop = e.target.offsetTop;
    const posLeft = Math.round(e.target.offsetLeft || 0);
    const elCenter = Math.round(e.target.offsetWidth || 0) / 2;
    const clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const term = context.querySelector(`.term-hint[data-term-id="${termId}"]`);

    term.style.top = posTop - 210 + 'px';
    if (clientWidth <= 1024) {
      term.style.left = '50%';
      term.style.right = 'initial';
      if (clientWidth <= 420) {
        term.style.marginLeft = '-150px';
      } else {
        term.style.marginLeft = '-190px';
      }
    } else {
      if (posLeft + elCenter < 190) {
        term.style.left = `${60}px`;
        term.style.right = 'initial';
      } else if ((clientWidth - posLeft - elCenter - 380) < 190) {
        term.style.left = 'initial';
        term.style.right = `${60}px`;
      } else {
        term.style.left = `${posLeft + elCenter - 190}px`
        term.style.right = 'initial';
      }
    }

    term.classList.add('visible');
    e.target.setAttribute('aria-expanded', 'true');
  }

  document.querySelectorAll('.term-reference')?.forEach((element) => element.addEventListener('click', (e) => {
    e.stopPropagation();
    showHintPopup(e);
  }));

  document.querySelectorAll('.term-reference')?.forEach((element) => element.addEventListener('keydown', (e) => {
    e.stopPropagation();
    // @ts-ignore
    if(e.keyCode === 13) {
      showHintPopup(e);
    }
    // @ts-ignore
    if(e.keyCode === 32) {
      showHintPopup(e);
    }
  }));

  // close visible term hint clicking anywhere
  document.querySelector('body')?.addEventListener('click', () => hideVisibleHint());

  // close visible term hint clicking on close button
  document.querySelectorAll('.term-hint .close-button')?.forEach((element) => element.addEventListener('click', () => hideVisibleHint()));

  // do not close visible term hint clicking on hint itself
  document.querySelectorAll('.term-hint')?.forEach((element) => element.addEventListener('click', (e) => e.stopPropagation()));
};
